import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Segment } from '../types/segment.type';
import { ADMIN_SEGMENTS_API_PATHS } from '../constants/segments-api-paths.constants';

type UseArchiveSegmentResult = {
  archiveSegment: (segmentId: string) => Promise<Segment | null>;
  isSubmitting: boolean;
};

export function useArchiveSegment(): UseArchiveSegmentResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const archiveSegment = async (segmentId: string): Promise<Segment | null> => {
    setIsSubmitting(true);

    try {
      const archivedSegment = await HttpClient.delete<Segment>(ADMIN_SEGMENTS_API_PATHS.ARCHIVE_SEGMENT(segmentId));

      enqueueSnackbar('Segment archivé', { variant: 'success' });
      return archivedSegment;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de l'archivage du segment"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { archiveSegment, isSubmitting };
}
